export const getToSelectData = (obj) =>
  Object.entries(obj).map(([key, value]) => ({
    label: key,
    value: value,
  }));
